import * as angular from 'angular';
import { TimeInterval, AggregationConfiguration, NameBuilderConfiguration, AggregationMode, PeriodReference, IPeriodConfiguration, IAggregationConfiguration } from '../../models';
import { OrderBy } from '../models/OrderBy';
import { ChartByIdentifierSeries } from './CharByIdentifierSeries';
import { ChartIdentifierConfigurationOptions } from './chartIdentifierConfigurationOptions';
import { infoTextColor } from '../../common/constants';

export class ChartIdentifierWidgetConfiguration implements IPeriodConfiguration, IAggregationConfiguration {
    aggregation: AggregationConfiguration;
    alignedOn: PeriodReference;
    isEndDateIncluded = false;
    maxPeriod: TimeInterval;
    minPeriod: TimeInterval;
    nameConfiguration: NameBuilderConfiguration;
    options: ChartIdentifierConfigurationOptions;
    series: ChartByIdentifierSeries[];

    constructor($translate: angular.translate.ITranslateService) {
        this.series = [];
        this.options = {
            barsSpacing: 50,
            color: infoTextColor,
            coloringMode: 1,
            isCircleVisible: false,
            isHorizontalLineVisible: false,
            isLabelsVisible: true,
            isLineVisible: false,
            isRectangleVisible: true,
            isTitleVisible: true,
            orderBy: OrderBy.Series,
            severities: [],
            showAlarms: false,
            showTarget: false,
            title: $translate.instant('Chart by identifier')
        };
        this.aggregation = new AggregationConfiguration();
        this.aggregation.period.interval = 0;
        this.aggregation.mode = AggregationMode.Average;
        this.nameConfiguration = new NameBuilderConfiguration();
        this.alignedOn = PeriodReference.End;
    }
}